export default __webpack_public_path__ + "static/bg-icons-a5f6d373f6e61d7729bacea68016df55.png";